exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".account-error-message{background-color:#ebd0d0;color:#960f0f;padding:4px;margin:4px 0}", ""]);

